import { SPOT_BASE_SIZE } from './RoomLayoutGrid.styles';

/**
 * Estimated legend block height before `onLayout` reports a real measurement.
 * Matches typical two-row legend + spacing in the member app spot-booking sheet.
 */
export const SPOT_LEGEND_HEIGHT_ESTIMATE_PX = 160;

export const SPOT_LEGEND_SPACER_MARGIN_TOP = SPOT_BASE_SIZE;

export const SPOT_LEGEND_SPACER_PADDING_BOTTOM = 24;

export function getPinchZoomMaxSlotHeight(
  pinchOverlayHeight: number,
  legendHeight: number,
  hideLegend = false
): number {
  if (pinchOverlayHeight <= 0) return 0;
  if (hideLegend) return pinchOverlayHeight;
  if (legendHeight > 0) {
    // Measured legendSpacer height includes paddingBottom; marginTop is outside the layout box.
    return Math.max(0, pinchOverlayHeight - legendHeight - SPOT_LEGEND_SPACER_MARGIN_TOP);
  }
  const legendReserve =
    SPOT_LEGEND_HEIGHT_ESTIMATE_PX +
    SPOT_LEGEND_SPACER_MARGIN_TOP +
    SPOT_LEGEND_SPACER_PADDING_BOTTOM;
  return Math.max(0, pinchOverlayHeight - legendReserve);
}
